import swal from 'sweetalert'

/* @ngInject */
function messageService ($translate) {
  var confirmButtonColors = {
    success: '#21ba45',
    error: '#EE2F47',
    warning: '#FBBD09',
    info: '#00abc8'
  }

  var service = {
    info,
    success,
    error,
    warning,
    input,
    defaultErrorMessage,
    defaultSuccessMessage
  }
  return service

  function info (oOptions) {
    return _displayMessage('info', _translateObject(oOptions))
  }

  function success (oOptions) {
    return _displayMessage('success', _translateObject(oOptions))
  }

  function error (oOptions) {
    return _displayMessage('error', _translateObject(oOptions))
  }

  function warning (oOptions) {
    return _displayMessage('warning', _translateObject(oOptions))
  }

  function input (oOptions) {
    return _displayMessage('input', _translateObject(oOptions))
  }

  function defaultErrorMessage () {
    var oOptions = {
      title: $translate.instant('oopsTitle'),
      text: $translate.instant('somethingWentWrongTryAgainMsg'),
      confirmButtonText: $translate.instant('ok')
    }
    return _displayMessage('error', oOptions)
  }

  function defaultSuccessMessage () {
    var oOptions = {
      title: $translate.instant('successTitle'),
      confirmButtonText: $translate.instant('ok')
    }
    return _displayMessage('success', oOptions)
  }

  function _translateObject (oOptions) {
    Object.keys(oOptions).map((key, index) => {
      if (typeof oOptions[key] !== 'function') {
        oOptions[key] = $translate.instant(oOptions[key])
      }
    })

    return oOptions
  }

  /**
    * @param oOptions {}
    *   oOptions.title               - message title
    *   oOptions.text                - message content
    *   oOptions.confirmButton       - message confirm button text
    *   oOptions.cancelButton        - message cancel button text
    *   oOptions.press               - message button click function handler
    *   oOptions.closeOnConfirm      - close message on confirm press
    *   oOptions.showLoaderOnConfirm - Show loader on confirm button when clicked
    *   oOptions.allowOutsideClick   - Allow user to click outside modal to close it
    **/
  function _displayMessage (sType, oOptions) {
    let confirmButtonColor = confirmButtonColors[sType]
    if (oOptions.dangerMode) {
      confirmButtonColor = confirmButtonColors.error
    }
    return swal({
      title: oOptions.title,
      text: oOptions.text,
      type: sType,
      confirmButtonColor: confirmButtonColor,
      confirmButtonText: oOptions.confirmButton,
      cancelButtonText: oOptions.cancelButton,
      showCancelButton: oOptions.cancelButton && oOptions.cancelButton !== '',
      closeOnConfirm: oOptions.closeOnConfirm,
      customClass: 'deskfy-swal-message',
      showLoaderOnConfirm: oOptions.showLoaderOnConfirm,
      allowOutsideClick: oOptions.allowOutsideClick,
      inputPlaceholder: oOptions.inputPlaceholder,
      html: oOptions.html
    }, oOptions.press)
  }
}

export { messageService }
